import { Breadcrumb } from "@platform/ui";
import { Link } from "react-router";
import { useTranslations } from "use-intl";

/** The way back from a record to its list in the console (card 114), as links: the list, then the record. */
export function ConsoleCrumb({ to, back, current }: { to: string; back: string; current: string }) {
  const t = useTranslations();
  return (
    <Breadcrumb
      label={t("common.breadcrumb")}
      items={[{ label: back, href: to }, { label: current }]}
      renderLink={(href, children, className) => (
        <Link to={href} className={className}>
          {children}
        </Link>
      )}
    />
  );
}
